
export const root = {
    transitionDuration: '{transition.duration}'
};

export const header = {
    borderColor: '{datatable.border.color}',
    borderWidth: '1px 0 1px 0',
    padding: '0.75rem 1rem',
    sm: {
        padding: '0.375rem 0.5rem'
    },
    lg: {
        padding: '1rem 1.25rem'
    }
};

export const headerCell = {
    selectedBackground: 'transparent',
    borderColor: '{surface.200}',
    hoverColor: '{content.hover.color}',
    selectedColor: '{highlight.color}',
    gap: '0.5rem',
    padding: '0.5rem 1rem',
    fontWeight: '400',
    fontSize: '0.75rem',
    borderBottom: '1px solid {surface.200}',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    },
    sm: {
        padding: '0.375rem 0.5rem'
    },
    lg: {
        padding: '1rem 1.25rem'
    }
};

export const columnTitle = {
    fontWeight: '600'
};

export const row = {
    background: 'transparent',
    hoverBackground: 'rgba(0, 0, 0, 0.02)',
    selectedBackground: 'rgba(239, 70, 0, 0.05)',
    color: '{content.color}',
    hoverColor: '{content.hover.color}',
    selectedColor: '{content.color}',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    }
};

export const bodyCell = {
    borderColor: 'transparent',
    padding: '0.75rem 1rem',
    borderWidth: '0',
    borderBottom: 'none',
    fontSize: '0.8125rem',
    sm: {
        padding: '0.375rem 0.5rem'
    },
    lg: {
        padding: '1rem 1.25rem'
    }
};

export const footerCell = {
    borderColor: '{datatable.border.color}',
    padding: '0.75rem 1rem',
    sm: {
        padding: '0.375rem 0.5rem'
    },
    lg: {
        padding: '1rem 1.25rem'
    }
};

export const columnFooter = {
    fontWeight: '700'
};

export const footer = {
    borderColor: '{datatable.border.color}',
    borderWidth: '0 0 1px 0',
    padding: '0.75rem 1rem',
    sm: {
        padding: '0.375rem 0.5rem'
    },
    lg: {
        padding: '1rem 1.25rem'
    }
};

export const dropPoint = {
    color: '{primary.color}'
};

export const columnResizer = {
    width: '0.5rem'
};

export const resizeIndicator = {
    width: '1px',
    color: '{primary.color}'
};

export const sortIcon = {
    color: '{text.muted.color}',
    hoverColor: '{text.muted.color}',
    activeColor: '{primary.color}',
    size: '0.625rem',
    opacity: '0.5',
    activeOpacity: '1'
};

export const loadingIcon = {
    size: '2rem'
};

export const rowToggleButton = {
    hoverBackground: '{content.hover.background}',
    selectedHoverBackground: '{content.background}',
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    selectedHoverColor: '{primary.color}',
    size: '1.75rem',
    borderRadius: '50%',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}'
    }
};

export const filter = {
    inlineGap: '0.5rem',
    overlaySelect: {
        background: '{overlay.select.background}',
        borderColor: '{overlay.select.border.color}',
        borderRadius: '{overlay.select.border.radius}',
        color: '{overlay.select.color}',
        shadow: '{overlay.select.shadow}'
    },
    overlayPopover: {
        background: '{overlay.popover.background}',
        borderColor: '{overlay.popover.border.color}',
        borderRadius: '{overlay.popover.border.radius}',
        color: '{overlay.popover.color}',
        shadow: '{overlay.popover.shadow}',
        padding: '{overlay.popover.padding}',
        gap: '0.5rem'
    },
    rule: {
        borderColor: '{content.border.color}'
    },
    constraintList: {
        padding: '{list.padding}',
        gap: '{list.gap}'
    },
    constraint: {
        focusBackground: '{list.option.focus.background}',
        selectedBackground: '{list.option.selected.background}',
        selectedFocusBackground: '{list.option.selected.focus.background}',
        color: '{list.option.color}',
        focusColor: '{list.option.focus.color}',
        selectedColor: '{list.option.selected.color}',
        selectedFocusColor: '{list.option.selected.focus.color}',
        separator: {
            borderColor: '{content.border.color}'
        },
        padding: '{list.option.padding}',
        borderRadius: '{list.option.border.radius}'
    }
};

export const paginatorTop = {
    borderColor: '{datatable.border.color}',
    borderWidth: '0 0 1px 0'
};

export const paginatorBottom = {
    borderColor: '{datatable.border.color}',
    borderWidth: '0 0 1px 0'
};

export const colorScheme = {
    light: {
        root: {
            borderColor: 'transparent'
        },
        header: {
            background: 'transparent',
            color: '{text.color}'
        },
        headerCell: {
            background: '{surface.ground}',
            hoverBackground: '{surface.ground}',
            color: '{text.muted.color}'
        },
        footer: {
            background: 'transparent',
            color: '{text.color}'
        },
        footerCell: {
            background: 'transparent',
            color: '{text.color}'
        },
        row: {
            stripedBackground: 'rgba(0, 0, 0, 0.02)',
            hoverBackground: '{surface.50}'
        },
        bodyCell: {
            selectedBorderColor: 'transparent'
        }
    },
    dark: {
        root: {
            borderColor: 'transparent'
        },
        header: {
            background: 'transparent',
            color: '{text.color}'
        },
        headerCell: {
            background: '{surface.ground}',
            hoverBackground: '{surface.ground}',
            color: '{text.color}',
            selectedBackground: 'transparent',
            selectedColor: '{text.color}'
        },
        footer: {
            background: 'transparent',
            color: '{text.color}'
        },
        footerCell: {
            background: 'transparent',
            color: '{text.color}'
        },
        row: {
            stripedBackground: 'rgba(255, 255, 255, 0.02)',
            hoverBackground: 'rgba(255, 255, 255, 0.04)',
            selectedBackground: 'rgba(239, 70, 0, 0.08)'
        },
        bodyCell: {
            selectedBorderColor: 'transparent'
        }
    }
};

// PrimeNG doesn't set font-size on table cells — they inherit 1rem from body.
// Header font-size is set via theme token but body cells need css callback.
export const css = ({dt}: {dt: (token: string) => string}) => `
.p-datatable-thead > tr > th {
    font-size: ${dt('datatable.header.cell.font.size')};
    font-weight: ${dt('datatable.header.cell.font.weight')};
    color: ${dt('datatable.header.cell.color')};
}
.p-datatable-tbody > tr > td {
    font-size: ${dt('datatable.body.cell.font.size')};
}
`;

export default {
    root,
    header,
    headerCell,
    columnTitle,
    row,
    bodyCell,
    footerCell,
    columnFooter,
    footer,
    dropPoint,
    columnResizer,
    resizeIndicator,
    sortIcon,
    loadingIcon,
    rowToggleButton,
    filter,
    paginatorTop,
    paginatorBottom,
    colorScheme,
    css
};
